import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { State } from './app.state';
import * as SummaryReducer from './summary/summary.reducer';
import { userReducer } from '@lmc-store/user';
import { permissionsReducer } from './permissions';
import { authReducer } from './auth/auth.reducer';

export const reducers: ActionReducerMap<State> = {
	summary: SummaryReducer.SummaryReducer,
	user: userReducer,
	permissions: permissionsReducer,
	auth: authReducer,
};

export const metaReducers: MetaReducer<State>[] = [];
